import React from "react";
import { Col } from "react-bootstrap";
import gutter from "src/functions/gutter";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";

function PricesIntroEn() {
  return (
    <>
      <Col xs={{ span: 12, order: 1 }} sm={6} lg={{ span: 4, order: 1 }}>
        <Heading type={`h2`} variant={`primary`} title={`Predaj po kusoch`} />
        <Paragraph size={`md`} width={`semibold`}>
          Plaťte iba za to, čo skutočne používate
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Chcete si kúpiť prémiový obsah, vyskúšať našu platformu alebo cvičíte
          iba občas? Vyberte si kurz alebo lekciu, ktorá vám vyhovuje a plaťte
          iba za to, čo si odcvičíte. Ceny obsahu si určujú lektori sami.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 3 }} sm={6} lg={{ span: 4, order: 2 }}>
        <Heading type={`h2`} variant={`primary`} title={`Predplatné`} />
        <Paragraph size={`md`} width={`semibold`}>
          Vyhovuje vám viac mesačné predplatné?
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Pre tých z vás, ktorí majú radi neobmedzený prístup k obsahu, máme
          dobrú správu. V blízkej budúcnosti spustíme predplatné. To vám umožní
          objavovať kurzy a lekcie rôznych lektorov bez obmedzení.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 5 }} sm={6} lg={{ span: 4, order: 3 }}>
        <Heading type={`h2`} variant={`primary`} title={`Obsah zadarmo`} />
        <Paragraph size={`md`} width={`semibold`}>
          Vyskúšajte ukážkové lekcie zadarmo!
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Chcete si vyskúšať, či vám prístup vybranej lektorky alebo lektora
          sedí, než si kúpite ponúkaný kurz alebo lekciu? Zobrazite si lektorský
          profil a nájdite ukážkové lekcie zadarmo. Sú označené značkou Ukážka.
          Vďaka tomu budete mať istotu, že ste zvolili správne.
        </Paragraph>
        <br />
      </Col>
    </>
  );
}

export default PricesIntroEn;
